/* eslint-disable @typescript-eslint/no-explicit-any */
import { PostHogProvider } from '@facephi/posthog-module';
import {
  InphiniteThemeProvider,
  ToastProvider,
  TimezoneProvider,
} from '@facephi/ui-react';
import { SkeletonTheme } from 'react-loading-skeleton';
import { RecoilRoot } from 'recoil';
import {
  AuthProvider,
  ConfigProvider,
  ExtendedSdkProvider,
  LogProvider,
  TranslationProvider,
  OperationProvider,
  DataProvider,
} from './providers';
import { Routes } from './routes/Routes';
import { timeZoneVar } from './states/cache';
import { GlobalStyles, SelphidDemoTheme } from './styles';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const sseUrl = (window as any)._env_.REACT_APP_SSE_URL;
const postHogApiKey: string = (window as any)._env_
  .REACT_APP_PUBLIC_POSTHOG_KEY;
const postHogOptions = {
  api_host: (window as any)._env_.REACT_APP_PUBLIC_POSTHOG_HOST,
};

export const App = () => {
  return (
    <InphiniteThemeProvider customTheme={SelphidDemoTheme}>
      <GlobalStyles />
      <SkeletonTheme baseColor="#D3D9ED" highlightColor="#F3F4F5">
        <TimezoneProvider setTimezone={timeZoneVar} timezone={timeZoneVar()}>
          <ToastProvider>
            <TranslationProvider>
              <LogProvider>
                <RecoilRoot>
                  <AuthProvider>
                    <ConfigProvider>
                      <DataProvider url={sseUrl}>
                        <OperationProvider>
                          <ExtendedSdkProvider>
                            <PostHogProvider
                              token={postHogApiKey}
                              options={postHogOptions}
                            >
                              <Routes />
                            </PostHogProvider>
                          </ExtendedSdkProvider>
                        </OperationProvider>
                      </DataProvider>
                    </ConfigProvider>
                  </AuthProvider>
                </RecoilRoot>
              </LogProvider>
            </TranslationProvider>
          </ToastProvider>
        </TimezoneProvider>
      </SkeletonTheme>
    </InphiniteThemeProvider>
  );
};
